<template>
  <nav
    id="navigation_menu"
    :class="{ reduce: !expandedMenu, }"
  >
    <slot name="logo">
      <router-link
        :to="{ name: 'home', }"
        :title="$t('404.page-accueil')"
      >
        <figure id="logos">
          <img
            id="logo_cristal"
            :src="require(`../../assets/media/logos/logo_cristal${darkMode ? '_white' : ''}.svg`)"
            :alt="$t('general.alt-logo-cristal')"
          />
          <figcaption
            v-if="expandedMenu"
            class="s4 bold"
            :class="{ 'dark-mode': darkMode, }"
          >
            Cristal
          </figcaption>
          <div v-if="expandedMenu">
            <img
              id="logo_lde"
              :src="require(`../../assets/media/logos/logo_lde${darkMode ? '_white' : ''}.svg`)"
              :alt="$t('general.alt-logo-lde')"
            />
          </div>
        </figure>
      </router-link>
    </slot>
    <div
      id="accordion_menu"
      :class="{ 'dark-mode': darkMode, }"
    >
      <div
        v-for="(link, index) in menu"
        :key="link.name"
        class="accordion-item"
        :class="{ opened: accordionOpenedIndex === index, }"
      >
        <div class="accordion-header flex-vcenter">
          <ButtonClassic
            :balise-type="link.submenu.length === 1 ? 'router-link' : 'button'"
            :variant="accordionOpenedIndex === index ? 'simple' : 'solid'"
            color="primary"
            :label="expandedMenu ? link.title() : null"
            icon="left"
            :disabled="accordionOpenedIndex === index"
            :router-link-obj="{ name: link.name, }"
            @click="accordionOpenedIndex = index"
          >
            <template #left-icon>
              <keep-alive>
                <component :is="link.icon" />
              </keep-alive>
            </template>
          </ButtonClassic>
        </div>
        <div
          class="collapse"
          :class="{ show: accordionOpenedIndex === index, }"
          data-bs-parent="#accordion_menu"
        >
          <div class="accordion-body">
            <ButtonClassic
              v-for="sublink in link.submenu"
              :key="sublink.name"
              :class="{ active: $route.name?.startsWith(`${link.name}_${sublink.name}`), }"
              :variant="accordionOpenedIndex === index ? 'simple' : 'solid'"
              color="primary"
              :label="expandedMenu ? sublink.title() : ''"
              v-bind="buttonAttr(link, sublink)"
            >
              <template #left-icon>
                <span class="circle" />
              </template>
              <template #right-icon>
                <UilExternalLinkAlt size="16" />
              </template>
            </ButtonClassic>
            <div
              v-if="expandedMenu && link.helper"
              class="italic catalogue-infos"
            >
              {{ link.helper }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { defineComponent } from "vue";
import ButtonClassic from "../../components/buttons/ButtonClassic.vue";

import { UilExternalLinkAlt } from "@lde/vue-unicons";

/**
 * Permet la navigation à travers le site.
 */
export default defineComponent({
  name: "NavigationMenu",
  components: {
    ButtonClassic,
    UilExternalLinkAlt,
  },
  props: {
    /**
     * Étend le menu en largeur.
     */
    expandedMenu: {
      type: Boolean,
      default: true,
    },
    /**
     * Change les couleurs du menu selon le mode choisi (jour ou nuit).
     */
    darkMode: {
      type: Boolean,
      default: false,
    },
    /**
     * Tableau des routes.
     */
    menu: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      accordionOpenedIndex: -1,
    };
  },
  watch: {
    // Permet de laisser le menu actuel déroulé au chargement de la page
    // Ne fonctionne pas au mounted (la route est chargée après) mais la page d'accueil est définie dans le router
    "$route.name": {
      handler() {
        const menuIndex = this.menu.findIndex(
          (parent) => parent.submenu.some(
            (child) => (this.$route.name.startsWith(`${parent.name}_${child.name}`)),
          ),
        );
        this.accordionOpenedIndex = menuIndex >= 0 ? menuIndex : -1;
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * Définit les attributs d'un bouton du menu.
     * @param {Object} link Informations d'un groupe d'onglet.
     * @param {Object} sublink Informations d'un lien d'un groupe.
     */
    buttonAttr(link, sublink) {
      if (sublink.extLink !== undefined) {
        return {
          baliseType: "a",
          extLink: sublink.extLink,
          icon: "both",
        };
      }

      return {
        baliseType: "router-link",
        routerLinkObj: { name: `${link.name}_${sublink.name}` },
        icon: "left",
      };
    },
  },
});
</script>

<style lang="scss">
@use "../../assets/styles/components/nav/navigation_menu.scss";
</style>
